export const isDev = process.env.NODE_ENV === "development";
export const isProd = process.env.NODE_ENV === "production";
export const isPreview = process.env.NODE_ENV === "preview";
export const isStaging = process.env.NODE_ENV === "staging";
